import useMediaQuery from "./useMediaQuery";

// 575.98px is the sm breakpoint the stylesheet uses to switch to mobile layouts.
export default function useIsMobile() {
  return useMediaQuery("(max-width: 575.98px)");
}
